$(function () {
    QuizHandler.getInstance().init();
});
